import { type ComputedArrivalData } from "../../ArrivalTime/computeArrivalData";
import { type ModalShiftData } from "../types";
import { type UseBookShiftProps } from "./useBookShift";

const DEFAULT_WORKPLACE_TIMEZONE = "America/Los_Angeles";

interface ConvertModalShiftDataToUseBookShiftParamsOptions extends Omit<
  UseBookShiftProps,
  "shift" | "workplace" | "workerPastShiftsCount"
> {
  shift: ModalShiftData;
  computedArrivalData?: ComputedArrivalData;
  rateNegotiationId: string | undefined;
}

export function convertModalShiftDataToUseBookShiftParams(
  options: ConvertModalShiftDataToUseBookShiftParamsOptions
): UseBookShiftProps {
  const { shift, computedArrivalData, rateNegotiationId, ...restProps } = options;

  const { id: shiftId, offer, worker, workplace, attributes: shiftAttributes } = shift;
  const { id: workplaceId, attributes: workplaceAttributes } = workplace;
  const { name: workplaceName, location, fullAddress } = workplaceAttributes;

  return {
    shift: {
      id: shiftId,
      offerId: offer?.id,
      start: shiftAttributes.start,
      end: shiftAttributes.end,
      qualification: shiftAttributes.qualification,
      computedArrivalData,
    },
    workplace: {
      id: workplaceId,
      name: workplaceName,
      address: {
        formattedAddress: fullAddress?.formatted ?? "",
        longitude: location.longitude.toString(),
        latitude: location.latitude.toString(),
      },
      timezone: location.timezone ?? DEFAULT_WORKPLACE_TIMEZONE,
      msa: location.msa ?? "",
      type: workplaceAttributes.type ?? "",
      preShiftOrientationLengthInMinutes: workplaceAttributes.preShiftOrientationLengthInMinutes,
    },
    workerPastShiftsCount: worker?.pastShiftsCount,
    rateNegotiationId,
    ...restProps,
  };
}
